import { number } from "../types/number";

export default function(a, b) {
  a = number(a);
  b = number(b);
  return a + b;
}
